import React, { useRef, useState } from "react";
import { RxPencil1 } from "react-icons/rx";
import { Link } from "react-router-dom";
import { MdAdd, MdProductCatalogingWatermark, MdLocationCity, MdOutlineDelete, MdOutlineGroup, MdRemoveRedEye } from "react-icons/md";
import { observer } from "mobx-react";
import Filter from "./ProductFilter/Filter";
import ReactPaginate from 'react-paginate';
import { ProductCatalogStore, useProductCatalogStore, ProductCatalogStoreContext } from "./Store/ProductCatalogStore";
import { useAuthStore } from "../Auth/store/Auth";
import { useEffect } from "react";
import Lightbox from "react-awesome-lightbox";
// You need to import the CSS only once
import "react-awesome-lightbox/build/style.css";
import { toast, ToastContainer } from "react-toastify";
import Moment from "react-moment";
import dem05 from "../assets/images/2.png"
import { Button, Input, Textarea } from "react-daisyui";
import axios from "axios";



const ProductCatalogList = () => {
    const store = new ProductCatalogStore({
        isloading: true,
        editloading: false
    });
    return (
        <ProductCatalogStoreContext.Provider value={store}>
            <Screen />
        </ProductCatalogStoreContext.Provider>
    )
}
export default ProductCatalogList;


const Screen = observer(() => {
    const {
        ProductCatalog,
        loadcity,
        nolist,
        Citypopup,
        designIdstatusChange,
        getPaginationDesginList,
        designIddeletefunction,
        getdesignIdstatus,
        BulkDelete,
        BulkstatusChange,
        addDesignId,
        setdesign_id,
        setProductIdpopup,
        getDesignList,
        designIdTotalPages,
        design_id,
        designId,
        ProductIdpopup,
        ProductCatalogLoader,
        designIdloder,
        ProductCatalogid,
        // setallProductCatalog,
        // allProductCatalog,
        setPaginationPage,
        setalldeactivate,
        alldeactivate,
        getProductCatalogList,
        getFilterProductCatalog,
        TotalPages,
        TotalDeginPages,
        setProductCatalogpopup,
        setPaginationDesginIdPage,
        ProductCatalogpopup,
        deletepopup,
        setdeletepopup,
        setdelateLoader,
        delateLoader,
        statusChange,
        setstatuspopup,
        getid,
        getstatus,
        deletefunction,
        setchecked,
        checkeddd,
        getToken
    } = useProductCatalogStore();

    const { adminAuthApproved, admin_permissions } = useAuthStore();

    useEffect(() => {
        if (adminAuthApproved) {
            getToken(localStorage.getItem("Admintoken"));
        }

    }, [adminAuthApproved]);

    const [currentPage, setCurrentPage] = useState(0);
    const [Key, setkey] = useState("none");
    const [uploadErrorData, setUploadErrorData] = useState(null);
    const [showUploadErrorPopup, setShowUploadErrorPopup] = useState(false);

    const [currentDesginPage, setDesginPage] = useState(0);
    const [lightboxIsOpen, setLightboxIsOpen] = useState(false);
    const [allProductCatalog, setallProductCatalog] = useState([])
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);

    const openModal = (image) => {
        setSelectedImage(image);
        setModalVisible(true);
    };

    const closeModal = () => {
        setModalVisible(false);
    };
    // const [checkeddd, setchecked] = useState(false)

    const [photoIndex, setPhotoIndex] = useState("");
    const [Index, setIndex] = useState("");

    const ITEMS_PER_PAGE = 10;
    const handlePageChange = ({ selected }) => {
        setPaginationPage(selected + 1);
        // getFilterProductCatalog();
        getFilterProductCatalog();
        setCurrentPage(selected);
    };
    const handlePageDesginChange = ({ selected }) => {
        setPaginationDesginIdPage(selected + 1);
        // getFilterProductCatalog();
        // getFilterProductCatalog();
        getPaginationDesginList()
        setDesginPage(selected);
    }

    const handleClick = () => {
        const element = document.getElementById("tablescroll");
        if (element) {
            element.scrollIntoView({ behavior: "smooth" });
        }
    }
    const handleImageError = (event) => {
        // This function will be called when the image fails to load
        event.target.src = dem05; // Replace with the path to your default image
    };
    const startIndex = currentPage * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;
    const ProductCatalogs = ProductCatalog?.slice(startIndex, endIndex);
    const BASE_URL = process.env.REACT_APP_BASE_URL;
    const [currentSlide, setCurrentSlide] = useState(0);
    const [isatend, setisatend] = useState(false);
    const [isAtBeginning, setisAtBeginning] = useState(false);
    const [Imagelength, setImagelength] = useState("");
    const [Imagearray, setImagearray] = useState([]);
    const [viewInput, setviewInput] = useState(false);
    const [loaderFile, setloaderFile] = useState(false);




    const prevSlide = (image) => {
        setCurrentSlide((prev) => (prev === 0 ? image.length - 1 : prev - 1));
        setisAtBeginning(currentSlide === 0)

    };

    const nextSlide = (image) => {
        setCurrentSlide((prev) => (prev === image.length - 1 ? 0 : prev + 1));
        setisatend(currentSlide === image.length - 1)
    };

    // Update isAtBeginning and isAtEnd when the currentSlide changes
    React.useEffect(() => {
        setisAtBeginning(currentSlide === 0);
        setisatend(currentSlide === Imagelength.length - 1);
    }, [currentSlide, Imagelength.length]);

    const openLightbox = (index) => {
        setLightboxIsOpen(true);
    };

    const closeLightbox = () => {
        setLightboxIsOpen(false);
    };

    const fileInputRef = useRef(null);

    const handleButtonClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.value = ''; // reset input
            fileInputRef.current.click();
        }
    };


    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        setloaderFile(true);

        if (!file) {
            setloaderFile(false);
            return;
        }

        const allowedTypes = [
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        ];

        if (!allowedTypes.includes(file.type)) {
            alert('Only .xls or .xlsx files are allowed');
            setloaderFile(false);
            return;
        }

        const formData = new FormData();
        formData.append('excel', file);

        try {
            const response = await axios.post(
                `${BASE_URL}/api/v1/admin/products/add-by-excel`,
                formData,
                {
                    responseType: 'blob',
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        authorization: `Bearer ${localStorage.getItem("Admintoken")}`,
                    },
                    validateStatus: () => true, // allow custom handling of all status codes
                }
            );

            const contentType = response.headers['content-type'];
            const contentDisposition = response.headers['content-disposition'];

            const blobText = await response.data.text(); // blob to text
            const parsedData = JSON.parse(blobText);

            if (response.status >= 200 && response.status < 300) {
                toast.success('Upload successful');
                getFilterProductCatalog();
                console.log(parsedData);
            } else {
                // Handle JSON validation error
                if (parsedData?.validation_error) {
                    setUploadErrorData(parsedData);
                    setShowUploadErrorPopup(true);
                } else {
                    toast.error('Upload failed');
                    alert(parsedData.message || 'Unknown error');
                }
            }

        } catch (err) {
            console.error('Error uploading file:', err);
            alert('Something went wrong');
        } finally {
            setloaderFile(false);
        }
    };






    const handleSubmit = (e, type) => {
        e.preventDefault();
        addDesignId(type);
        // Perform API call or any other logic using MobX store data
        // Example: addCity();
    };

    return (
        <>
            <div className="flex justify-between mt-[51px] ">
                <div className=" mb-4">
                    <p className=" text-2xl font-semibold">Product Catalog Management</p>
                    <p className=" opacity-80 text-sm">Home / Product Catalog </p>
                </div>
                <div className="flex gap-2">
                    <button
                        onClick={handleButtonClick}
                        className="btn btn-sm bg-[#000] text-color_theme text-sm hover:bg-[#000]"
                    >
                        Upload Excel File
                    </button>
                    <input
                        type="file"
                        ref={fileInputRef}
                        onChange={handleFileChange}
                        accept=".xls,.xlsx"
                        style={{ display: 'none' }}
                    />
                    <Link
                        to="./addproductcatalog"
                        className="btn btn-sm bg-[#000] text-color_theme text-sm hover:bg-[#000]"
                    >
                        <MdAdd />
                        Add ProductCatalog
                    </Link>
                </div>
            </div>
            <Filter />


            <div className="card bg-base-100 shadow-md p-6 mt-8">
                <div className="overflow-x-auto w-full">
                    <table id="tablescroll" className="table table-zebra w-full">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Images</th>
                                <th>Name</th>
                                <th>SKU</th>
                                <th>Created On</th>
                                <th>Approved</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>

                        <tbody className="text-sm relative">
                            {(loaderFile || ProductCatalogLoader) &&
                                <>
                                    <tr>
                                        <td colSpan={8} className="animate-pulse py-6"></td>
                                    </tr>
                                    <tr>
                                        <td colSpan={8} className="animate-pulse py-6"></td>
                                    </tr>
                                    <tr>
                                        <td colSpan={8} className="animate-pulse py-6"></td>
                                    </tr>
                                    <tr>
                                        <td colSpan={8} className="animate-pulse py-6"></td>
                                    </tr>
                                    <tr>
                                        <td colSpan={8} className="animate-pulse py-6"></td>
                                    </tr>
                                </>
                            }
                            {
                                (ProductCatalogs.length === 0 ? ProductCatalog : ProductCatalogs)?.map((data, index) => (
                                    <tr key={index} className="capitalize">
                                        <td>                                    {currentPage * ITEMS_PER_PAGE + index + 1}
                                        </td>
                                        <td
                                            onClick={() => { setImagearray(data.product_image); data?.product_image?.length != 0 && openLightbox() }}

                                        >
                                            <label
                                                htmlFor="imagecarousel"
                                                className=" flex space-x-[-5px] cursor-pointer"
                                                title="Delete"

                                            >
                                                {

                                                    data?.product_image?.length ?

                                                        data?.product_image?.length > 3 ?
                                                            <>

                                                                <img

                                                                    onError={handleImageError}
                                                                    alt="ProductCatalog Image" className="w-[35px] bg-white transition duration-300 hover:opacity-70 rounded-full border-[2px] p-1 border-[#d7d7d7] cursor-pointer h-[35px]" crossOrigin="anonymous" src={data?.product_image[0]?.includes("cloudinary")
                                                                        ? data?.product_image[0]
                                                                        : BASE_URL + `/uploads/product/${data?.product_image[0]}`} />
                                                                <img

                                                                    onError={handleImageError}
                                                                    alt="ProductCatalog Image" className="w-[35px] bg-white transition duration-300 hover:opacity-70 rounded-full border-[2px] p-1 border-[#d7d7d7] cursor-pointer h-[35px]" crossOrigin="anonymous" src={data?.product_image[1]?.includes("cloudinary")
                                                                        ? data?.product_image[1]
                                                                        : BASE_URL + `/uploads/product/${data?.product_image[1]}`} />
                                                                <img

                                                                    onError={handleImageError}
                                                                    alt="ProductCatalog Image" className="w-[35px] bg-white transition duration-300 hover:opacity-70 rounded-full border-[2px] p-1 border-[#d7d7d7] cursor-pointer h-[35px]" crossOrigin="anonymous" src={data?.product_image[0]?.includes("cloudinary")
                                                                        ? data?.product_image[0]
                                                                        : BASE_URL + `/uploads/product/${data?.product_image[2]}`} />

                                                            </>

                                                            :




                                                            data?.product_image.map((images, index) => (
                                                                <>

                                                                    <img

                                                                        onError={handleImageError}
                                                                        alt="ProductCatalog Image" className="w-[35px] bg-white transition duration-300 hover:opacity-70 rounded-full border-[2px] p-1 border-[#d7d7d7] cursor-pointer h-[35px]" crossOrigin="anonymous" src={images?.includes("cloudinary") ? images : BASE_URL + `/uploads/product/${images}`} />

                                                                    {console.log(BASE_URL + `/uploads/product/${images}`)}
                                                                </>
                                                            ))
                                                        :
                                                        "No Image"

                                                }
                                                {data?.product_image?.length > 3 &&

                                                    <div className="w-[35px]  flex justify-center items-center rounded-full border-[2px] p-1 border-[#d7d7d7] bg-white cursor-pointer h-[35px]">
                                                        +3
                                                    </div>
                                                }

                                            </label>

                                        </td>
                                        <td>
                                            {data?.product_name}
                                        </td>
                                        <td>
                                            {data?.product_id}
                                        </td>
                                        <td>
                                            <Moment
                                                format={
                                                    "DD/MM/YYYY"
                                                }
                                            >
                                                {data?.created_date_time}
                                            </Moment>
                                        </td>

                                        <td>
                                            <label
                                                title="Change Status"
                                                htmlFor="my-modal-5"
                                                className={`btn capitalize Active" ${data?.is_verified === 1 ? "bg-[#1dc9b7] hover:bg-[#1dc9b7]" : "bg-error hover:bg-error"}  text-[#000] border-hidden  btn-xs`}

                                            // onClick={(e) => {
                                            //     getid(data?.id);
                                            //     setProductCatalogpopup(true);
                                            //     getstatus(data?.is_active === 1 ? 0 : 1);
                                            // }}
                                            >
                                                {data?.is_verified === 1 ? "Approved" : "Disapproved"}
                                            </label>
                                        </td>





                                        <th >
                                            <div className="flex space-x-3">
                                                {admin_permissions.products === 1 ?
                                                    <label
                                                        title="Change Status"
                                                        htmlFor="my-modal-5"
                                                        className={`btn capitalize Active" ${data?.is_active === 1 ? "bg-[#5dff5d] hover:bg-[#5dff5d]" : "bg-warning hover:bg-warning"}  text-[#000] border-hidden  btn-xs`}
                                                        onClick={(e) => {
                                                            getid(data?.product_id);
                                                            setProductCatalogpopup(true);
                                                            getstatus(data?.is_active === 1 ? 0 : 1);
                                                        }}
                                                    >
                                                        {data?.is_active === 1 ? "Active" : "Inactive"}
                                                    </label>
                                                    :
                                                    <label
                                                        title="Change Status"
                                                        htmlFor="my-modal-5"
                                                        className={`btn capitalize Active" ${data?.is_active === 1 ? "bg-[#5dff5d] hover:bg-[#5dff5d]" : "bg-warning hover:bg-warning"}  text-[#000] border-hidden  btn-xs`}

                                                        onClick={(e) => {
                                                            toast.warning("You have no permissions to edit.")
                                                        }}
                                                    >
                                                        {data?.is_active === 1 ? "Active" : "Inactive"}
                                                    </label>
                                                }
                                            </div>

                                        </th>
                                        <th >
                                            <div className="flex  space-x-3">

                                                <div className="flex items-center space-x-3">
                                                    {admin_permissions.products === 1 ?
                                                        <label
                                                            htmlFor="deletecity"
                                                            className=" text-[#d02c2c] cursor-pointer"
                                                            title="Delete"
                                                            onClick={() => { setdeletepopup(true); getid(data?.product_id) }}
                                                        >
                                                            <MdOutlineDelete />
                                                        </label>
                                                        :
                                                        <label
                                                            htmlFor="deletecity"
                                                            className=" text-[#d02c2c] cursor-pointer"
                                                            title="Delete"
                                                            onClick={() => { toast.warning("You have no permissions to edit.") }}
                                                        >
                                                            <MdOutlineDelete />
                                                        </label>
                                                    }
                                                    {/* {admin_permissions.ProductCatalog === 1 ? */}
                                                    <button title="Edit">
                                                        <Link to={`/productcatalog/${data?.product_id}`}>
                                                            <RxPencil1 />
                                                        </Link>
                                                    </button>

                                                    {/* :
                                                        <button onClick={() => toast.warning("You have no permissions to edit.")} title="Edit">

                                                            <RxPencil1 />

                                                        </button>
                                                    } */}

                                                </div>
                                                <div className="flex items-center space-x-3">

                                                    {/* <label
                                                        title="View DesignId's"
                                                        htmlFor="my-modal-7"
                                                        onClick={() => {
                                                            getDesignList(data?.product_id);
                                                            getid(data?.product_id);
                                                            setProductIdpopup(true);
                                                        }}
                                                        className={`btn capitalize  text-white border-hidden  btn-xs`}

                                                    > */}
                                                    <Link to={`/desgincategory/${data.product_id}`} >
                                                        <MdRemoveRedEye />
                                                    </Link>



                                                    {/* </label> */}



                                                    {/* {admin_permissions.Product === 1 ? */}

                                                    {/* :
    <button onClick={() => toast.warning("You have no permissions to edit.")} title="Edit">

        <RxPencil1 />

    </button>
} */}

                                                </div>
                                            </div>

                                        </th>

                                    </tr>
                                ))
                            }

                            {nolist &&
                                <tr>
                                    <td colSpan={7} className="my-10 text-center">
                                        <MdOutlineGroup className=" text-[#dedede] text-8xl mx-auto" />
                                        <p className=" font-semibold text-lg">No ProductCatalog Found</p>
                                        <Link
                                            to="./addproductcatalog"
                                            className="btn btn-sm mt-4 bg-[#000] text-color_theme text-sm hover:bg-[#000]"
                                        >
                                            <MdAdd />
                                            Add ProductCatalog
                                        </Link>
                                    </td>
                                </tr>}
                        </tbody>
                    </table>
                    {/* {!city?.length == 0 && */}

                    <ReactPaginate
                        initialPage={0}
                        pageCount={Math.ceil(TotalPages)}
                        pageRangeDisplayed={5}
                        marginPagesDisplayed={2}
                        onPageChange={handlePageChange}
                        onClick={handleClick}
                        containerClassName={'pagination'}
                        activeClassName={'active'}

                    />
                    {/* } */}

                    {/* status change model start */}
                    {/* <div className="modal">
            <div className="modal-box relative">
              <label
                htmlFor="my-modal-5"
                className="btn btn-sm btn-circle absolute right-2 top-2"
              >
                ✕
              </label>
              <h3 className="text-lg font-bold text-center">
                Are you sure you want to change Status ?
              </h3>
              <div className="modal-action justify-center">
                      <label
                        htmlFor="my-modal-5"
                        className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ml-4"
                        onClick={() => statusChange()}
                      >
                        Yes
                      </label> 
                <label htmlFor="my-modal-5" className="btn btn-md bg-[#000] text-color_theme text-sm hover:bg-[#000]">
                  No
                </label>
              </div>
            </div>
          </div> */}
                    {/* status change model end */}

                    {deletepopup &&
                        <>
                            <input type="checkbox" id="deletecity" className="modal-toggle" />
                            <div className="modal">
                                <div className="modal-box relative">
                                    <label

                                        className="btn btn-sm btn-circle absolute right-2 top-2"
                                        onClick={() => { setdelateLoader(false); setdeletepopup(false) }}
                                    >
                                        ✕
                                    </label>
                                    <h3 className="text-lg font-bold text-center">
                                        Are you sure you want to Delete this Section
                                    </h3>
                                    <div className="modal-action justify-center">
                                        {/* <label
                                            htmlFor="deletecity"
                                            className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ml-4"
                                            onClick={() => deletefunction()}
                                        >
                                            Yes
                                        </label> */}
                                        {!delateLoader ?
                                            <label

                                                className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ml-4"
                                                onClick={() => deletefunction()}
                                            >
                                                Yes
                                            </label> :
                                            <button
                                                // type="submit"
                                                disabled
                                                className="flex items-center bg-color_theme px-3 mx-5 rounded-md"
                                            // onClick={() => {
                                            //   PostMatchscore();
                                            // }}
                                            >
                                                Yes..
                                                <svg
                                                    className="animate-spin mr-1 h-5 w-5 text-white"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <circle
                                                        className="opacity-25"
                                                        cx="12"
                                                        cy="12"
                                                        r="10"
                                                        stroke="currentColor"
                                                        strokeWidth="4"
                                                    ></circle>
                                                    <path
                                                        className="opacity-75"
                                                        fill="currentColor"
                                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                    ></path>
                                                </svg>
                                            </button>}
                                        <label
                                            onClick={() => setdeletepopup(false)}
                                            className="btn btn-md bg-[#000] text-color_theme text-sm hover:bg-[#000]">
                                            No
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </>

                    }

                    {lightboxIsOpen &&
                        <>
                            <input type="checkbox" id="imagecarousel" className="modal-toggle" />
                            <div className="modal  w-full">
                                <div className="modal-box relative">
                                    <label

                                        className="btn btn-sm btn-circle absolute right-2 top-2"
                                        onClick={() => { setdelateLoader(false); setCurrentSlide(0); setLightboxIsOpen(false) }}
                                    >
                                        ✕
                                    </label>
                                    <div className="modal-action justify-center">
                                        {Imagearray?.length > 0 && (
                                            <div className="carousel w-[55%]">
                                                {Imagearray?.map((image, i) => (
                                                    <div
                                                        key={i}
                                                        id={`slide${i}`}
                                                        className={`carousel-item relative w-full ${i === currentSlide ? 'visible' : 'hidden'}`}
                                                    >
                                                        <img
                                                            onError={handleImageError}
                                                            crossOrigin="anonymous" src={image?.includes("cloudinary")
                                                                ? image
                                                                : BASE_URL + `/uploads/product/${image}`} className="w-[80%]  ml-[10%]  h-[95%]" />
                                                    </div>
                                                ))}
                                                {Imagearray?.length > 1 &&
                                                    <div className="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">

                                                        <button disabled={isAtBeginning} onClick={() => { prevSlide(Imagearray); setImagelength(Imagearray); }} className={`btn btn-circle`}>
                                                            ❮
                                                        </button>

                                                        <button disabled={isatend} onClick={() => { nextSlide(Imagearray); setImagelength(Imagearray); }} className={`btn btn-circle`}>
                                                            ❯
                                                        </button>



                                                    </div>
                                                }

                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </>

                    }


                    {ProductIdpopup &&
                        <>
                            <input type="checkbox" id="my-modal-7" className="modal-toggle" />
                            <div className="modal">
                                <div className="modal-box space-y-5 relative">
                                    <label

                                        className="btn btn-sm btn-circle  absolute right-2 top-2"
                                        onClick={() => {
                                            setProductIdpopup(false);
                                            //  setProductIdIndex(null); 
                                        }}
                                    >
                                        x
                                    </label>
                                    <div className="space-y-2">

                                        <div className="flex space-x-5 text-center items-center">
                                            <div className="flex w-full max-h-[330px] overflow-auto   ">
                                                <table id="tablescroll" className="table table-zebra w-full">
                                                    <thead>
                                                        <tr>
                                                            <th></th>
                                                            <th>Design ID</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody className="text-sm relative">
                                                        {designIdloder &&
                                                            <>
                                                                <tr>
                                                                    <td colSpan={7} className="animate-pulse py-6"></td>
                                                                </tr>
                                                                <tr>
                                                                    <td colSpan={7} className="animate-pulse py-6"></td>
                                                                </tr>
                                                                <tr>
                                                                    <td colSpan={7} className="animate-pulse py-6"></td>
                                                                </tr>
                                                                <tr>
                                                                    <td colSpan={7} className="animate-pulse py-6"></td>
                                                                </tr>
                                                                <tr>
                                                                    <td colSpan={7} className="animate-pulse py-6"></td>
                                                                </tr>
                                                            </>
                                                        }
                                                        {
                                                            (designId.length === 0 ? designId : designId)?.map((data, index) => (
                                                                <tr key={index} className="capitalize">
                                                                    <td>                                    {currentDesginPage * ITEMS_PER_PAGE + index + 1}
                                                                    </td>
                                                                    <td


                                                                    >

                                                                        {data?.design_id}


                                                                    </td>







                                                                    <th >



                                                                        <div className="flex items-center space-x-3">
                                                                            <span

                                                                                className={`btn capitalize Active" ${data?.is_active === 1 ? "bg-[#5dff5d] hover:bg-[#5dff5d]" : "bg-warning hover:bg-warning"}  text-[#000] border-hidden  btn-xs`}
                                                                                onClick={(e) => {
                                                                                    // getid(data?.product_id);
                                                                                    designIdstatusChange(data?.record_id, data?.is_active === 1 ? 0 : 1)
                                                                                    // getdesignIdstatus(data?.is_active === 1 ? 0 : 1);
                                                                                }}
                                                                            >
                                                                                {data?.is_active === 1 ? "Active" : "Inactive"}
                                                                            </span>
                                                                            <label
                                                                                htmlFor="deletecity"
                                                                                className=" text-[#d02c2c] cursor-pointer"
                                                                                title="Delete"
                                                                                onClick={() => { designIddeletefunction(data?.record_id); }}
                                                                            >
                                                                                <MdOutlineDelete />
                                                                            </label>


                                                                        </div>


                                                                    </th>


                                                                </tr>
                                                            ))
                                                        }


                                                    </tbody>
                                                </table>

                                            </div>


                                        </div>
                                        {designId.length > 0 &&

                                            <ReactPaginate
                                                initialPage={0}
                                                pageCount={Math.ceil(TotalDeginPages)}
                                                pageRangeDisplayed={5}
                                                marginPagesDisplayed={2}
                                                onPageChange={handlePageDesginChange}
                                                onClick={handleClick}
                                                containerClassName={'pagination'}
                                                activeClassName={'active'}

                                            />
                                        }

                                        {/* <ReactPaginate
                                            initialPage={0}
                                            pageCount={Math.ceil(designIdTotalPages)}
                                            pageRangeDisplayed={5}
                                            marginPagesDisplayed={2}
                                            onPageChange={handlePageChange}
                                            onClick={handleClick}
                                            containerClassName={'pagination'}
                                            activeClassName={'active'}

                                        /> */}


                                        {/* {designId.length == 0 &&
                                            <Button
                                                onClick={() => setviewInput(true)}
                                                className="flex justify-center items-center text-center text-[white]">
                                                Add DesignId'S</Button>

                                        } */}
                                        {Key == "none" &&
                                            <div className=" flex justify-center items-center gap-3">

                                                <button
                                                    onClick={() => setkey("single")}
                                                    className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ml-4">
                                                    <MdAdd className="mr-1" />
                                                    Single Design Id
                                                </button>
                                                <button
                                                    onClick={() => setkey("multi")}
                                                    className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ml-4">
                                                    <MdAdd className="mr-1" />
                                                    Muliple Design Id
                                                </button>
                                            </div>
                                        }

                                        {Key == "single" &&
                                            <form onSubmit={(e) => handleSubmit(e, "single")}>
                                                <div className="space-y-2">
                                                    <Input
                                                        name="Design id"
                                                        value={design_id}
                                                        onChange={(e) => setdesign_id(e.target.value, "single")}
                                                        required
                                                        placeholder="Design id"
                                                        id="Design id"
                                                        type="text"
                                                        autoComplete="off"
                                                        className=" focus:outline-0 w-full text-sm font-medium rounded-md"
                                                    />


                                                </div>
                                                <div className=" flex space-x-1 items-center justify-end mt-3">
                                                    <span className="underline cursor-pointer  " onClick={() => setkey("none")}  > Cancel</span>
                                                    <button

                                                        className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ml-4">
                                                        <MdAdd className="mr-1" />
                                                        add
                                                    </button>


                                                </div>

                                            </form>
                                        }
                                        {Key == "multi" &&

                                            <form onSubmit={(e) => handleSubmit(e, "multi")}>
                                                <div className="space-y-2">
                                                    <Textarea
                                                        name="Design id"
                                                        value={design_id}
                                                        onChange={(e) => setdesign_id(e.target.value, "multi")}
                                                        required
                                                        placeholder='Please Paste Array of String i.e ["designId1" , "designId2" ,  "designId3" ]'
                                                        id="Design id"
                                                        type="text"
                                                        autoComplete="off"
                                                        className=" focus:outline-0 w-full text-sm font-medium rounded-md"
                                                    />


                                                </div>
                                                <div className=" flex space-x-1 items-center justify-end mt-3">
                                                    <span className="underline cursor-pointer  " onClick={() => setkey("none")}  > Cancel</span>
                                                    <button

                                                        className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ml-4">
                                                        <MdAdd className="mr-1" />
                                                        add
                                                    </button>


                                                </div>

                                            </form>

                                        }

                                    </div>

                                </div>
                            </div>

                        </>
                    }
                    {ProductCatalogpopup &&
                        <>
                            <input type="checkbox" id="my-modal-5" className="modal-toggle" />
                            <div className="modal">
                                <div className="modal-box relative">
                                    <label

                                        className="btn btn-sm btn-circle absolute right-2 top-2"
                                        onClick={() => setProductCatalogpopup(false)}
                                    >
                                        ✕
                                    </label>
                                    <h3 className="text-lg font-bold text-center">
                                        Are you sure you want to change Status ?
                                    </h3>
                                    <div className="modal-action justify-center">
                                        {!ProductCatalogLoader ? <label

                                            className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ml-4"
                                            onClick={() => statusChange()}
                                        >
                                            Yes
                                        </label> :
                                            <button
                                                // type="submit"
                                                disabled
                                                className="flex items-center bg-color_theme px-3 mx-5 rounded-md"
                                            // onClick={() => {
                                            //   PostMatchscore();
                                            // }}
                                            >
                                                Yes..
                                                <svg
                                                    className="animate-spin mr-1 h-5 w-5 text-white"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <circle
                                                        className="opacity-25"
                                                        cx="12"
                                                        cy="12"
                                                        r="10"
                                                        stroke="currentColor"
                                                        strokeWidth="4"
                                                    ></circle>
                                                    <path
                                                        className="opacity-75"
                                                        fill="currentColor"
                                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                    ></path>
                                                </svg>
                                            </button>}

                                        <label
                                            onClick={() => setProductCatalogpopup(false)}
                                            // htmlFor="voidstatus"
                                            className="btn btn-md bg-[#000] text-color_theme text-sm hover:bg-[#000]"
                                        >
                                            No
                                        </label>
                                    </div>
                                </div>
                            </div>

                        </>

                    }
                    {showUploadErrorPopup && (
                        <>
                            <input type="checkbox" id="upload-error-modal" className="modal-toggle" checked readOnly />
                            <div className="modal">
                                <div className="modal-box max-w-2xl relative">
                                    <label
                                        className="btn btn-sm btn-circle absolute right-2 top-2"
                                        onClick={() => setShowUploadErrorPopup(false)}
                                    >
                                        ✕
                                    </label>
                                    <h3 className="text-lg font-bold text-center text-red-600 mb-4">
                                        Upload Failed: Validation Error
                                    </h3>
                                    <p className="text-sm font-medium mb-2">{uploadErrorData?.message}</p>
                                    <div className="max-h-64 overflow-y-auto border border-gray-300 p-3 rounded-md bg-gray-50">
                                        {Object.entries(uploadErrorData || {})
                                            .filter(([key]) => !['status', 'message', 'validation_error'].includes(key))
                                            .map(([key, val]) => (
                                                <div key={key} className="mb-2">
                                                    <p className="font-semibold text-gray-800">{key}:</p>
                                                    <p className="text-sm text-red-700">{val}</p>
                                                </div>
                                            ))}
                                    </div>
                                    <div className="modal-action justify-center mt-4">
                                        <label
                                            onClick={() => setShowUploadErrorPopup(false)}
                                            className="btn bg-[#000] text-color_theme hover:bg-[#111]"
                                        >
                                            Close
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}

                </div>
            </div>
        </>
    );
});

